module.exports = __webpack_public_path__ + "img/image-13.b74457ff.jpeg";